import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate,useParams } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Button } from "primereact/button";
import {Row} from "react-bootstrap";
import { InputNumber } from 'primereact/inputnumber';
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import {ProductsList} from "../ProductsList/ProductsList";

const ProductDetails = () => {

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const productFromState = location.state?.product;
    const product = productFromState || ProductsList.find(p => p.id === id);
    const [quantity, setQuantity] = useState(1);
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedSize, setSelectedSize] = useState('');
    const storageKey = `cartItem-${product?.id}`;

    useEffect(() => {
        if (product) {
            setSelectedColor(product.colors?.[0]?.name || '');
            setSelectedImage(product.colors?.[0]?.image || product.image);
            setSelectedSize(product.sizes?.[0] || '');
        }
    }, [product]);

    const OnClickAddToCart = () => {
        const cleanPrice = parseFloat(
            product.price
                .replace(/Rs\.?/g, '')
                .replace(/,/g, '')
                .trim()
        );
        const formatPrice = (value) => {
            return new Intl.NumberFormat('en-IN').format(value);
        };
        console.log("Clean Price:", cleanPrice);
        console.log("quantity", quantity);
        const addingItemsInCart = {
            productName: product.name,
            // productImage : product.image,
            productImage : selectedImage,
            productPrice: product.price,
            productQuantity: quantity,
            productColor: selectedColor,
            productSize: selectedSize,
            productTotal: formatPrice(quantity * cleanPrice),
        }

        localStorage.setItem(storageKey, JSON.stringify(addingItemsInCart));

        setOpenSnackbar(true);
    }

    const addingItemsInCart = JSON.parse(localStorage.getItem(storageKey));
    useEffect(() => {
        if(addingItemsInCart?.productQuantity)
        {
            setQuantity(addingItemsInCart?.productQuantity)
        }
    }, [addingItemsInCart?.productQuantity]);

    if (!product) {
        return <div className="text-center mt-5">Product not found</div>;
    }
    return (
        <>
            <div className="container custom-container-md py-5 mt-5">
                <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                    <Alert onClose={() => setOpenSnackbar(false)} severity="success" variant="filled" sx={{ width: '100%' }}>Cart Update Successfully!</Alert>
                </Snackbar>
                <NavBar/>
                <div className="breadcrumb mb-3"  style={{ paddingTop: "10rem" }}>
                    <span className="breadcrumb-item text-decoration-none" onClick={() => navigate('/')}>Home</span>
                    <span className="breadcrumb-separator">›</span>
                    <span className="breadcrumb-item text-decoration-none" onClick={() => navigate('/products')}>Products</span>
                    <span className="breadcrumb-separator">›</span>
                    <span className="breadcrumb-current">{product.name}</span>
                </div>
                <div className="row align-items-start">
                    <div className="col-md-6 text-center">
                        <img src={selectedImage} alt={product.name} className="w-100 custom-product-detail-image" loading="lazy"/>
                    </div>
                    <div className="col-md-6">
                        <h3 className="fw-bold">{product.name}</h3>
                        <p className="text-primary fs-5">Price: {product.price || 'N/A'}</p>
                        <div className="mb-3">
                            <strong>Color: </strong> <span>{selectedColor}</span>
                            <div className="mt-2 d-flex flex-wrap gap-2">
                                {product.colors.map(color => (
                                    <Button key={color.name} label={color.name} rounded outlined={selectedColor === color.name ? 'text-green' : 'text-black'} onClick={() => {setSelectedColor(color.name);setSelectedImage(color.image);}} className={selectedColor === color.name ? 'text-green' : 'text-black'} style={{borderRadius: '20px', textTransform: 'none', fontWeight: 'bold', fontSize: '14px'}}/>
                                ))}
                            </div>
                        </div>
                        <div className="mb-3">
                            <strong>Size: </strong> <span>{selectedSize}</span>
                            <div className="mt-2 d-flex flex-wrap gap-2">
                                {product.sizes.map(size => (
                                    <Button key={size} label={size} rounded outlined={selectedSize === size ? 'text-green' : 'text-black'} onClick={() => setSelectedSize(size)} className={selectedSize === size ? 'text-green' : 'text-black'} style={{borderRadius: '20px', textTransform: 'none', fontWeight: 'bold', fontSize: '14px', '&:hover': {backgroundColor: '#fff', borderColor: '#A6CE3A'}}}/>
                                ))}
                            </div>
                        </div>
                        <div className="mt-4">
                            <p>
                                <strong>The {product.name}</strong> is specially designed with<strong> superior performance</strong> and<strong> durability</strong> in mind. It is perfect for the office, home, or projects. The simple yet elegant design makes it<strong> perfect for any space</strong>.
                            </p>
                        </div>
                        <div className="my-4 d-flex flex-column gap-3">
                            <div className="d-flex align-items-center gap-3">
                                <strong>Quantity:</strong>
                                <InputNumber value={quantity} onValueChange={(e) => setQuantity(e.value)} showButtons buttonLayout="horizontal" step={1} min={1} className="custom-quantity-input" decrementButtonClassName="custom-quantity-btn" incrementButtonClassName="custom-quantity-btn" incrementButtonIcon={<span style={{ fontSize: '1.2rem' }}>+</span>} decrementButtonIcon={<span style={{ fontSize: '1.2rem' }}>−</span>}/>
                            </div>
                        </div>
                        <Row className="m-0">
                            <Button icon="pi pi-shopping-cart" label="Add To Cart" severity="success" outlined onClick={OnClickAddToCart} className='text-green'/>
                        </Row>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
};
export default ProductDetails;